export default "__VITE_PUBLIC_ASSET__182ef0ce__"